 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_SERIES_PAGE from '@/components/xhtml/01_Series_Page'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_PROLOGUE from '@/components/xhtml/06_Prologue'
 import XHTML07_THE_WORLD_OF_ANIMATION_AND_THE_A from '@/components/xhtml/07_The_World_of_Animation_and_the_A'
 import XHTML08_THE_LEGO_MOVIE_AS_SAVVY_CINEMA from '@/components/xhtml/08_The_LEGO_Movie_as_Savvy_Cinema'
 import XHTML09_THROUGH_THE_RABBIT_HOLE__INTO_TH from '@/components/xhtml/09_Through_the_Rabbit_Hole__into_th'
 import XHTML10_FALLING_INTO_NARRATIVE from '@/components/xhtml/10_Falling_into_Narrative'
 import XHTML11_THE_EXTRAORDINARY_ORDINARINESS_O from '@/components/xhtml/11_The_Extraordinary_Ordinariness_o'
 import XHTML12_THE_SECRET_LIFE_OF_TOYS from '@/components/xhtml/12_The_Secret_Life_of_Toys'
 import XHTML13_PRODUCTION_HISTORY__PART_1__PROJ from '@/components/xhtml/13_Production_History__Part_1__Proj'
 import XHTML14_PRODUCTION_HISTORY__PART_2__THE from '@/components/xhtml/14_Production_History__Part_2__The'
 import XHTML15_PRODUCTION_HISTORY__PART_3__THE from '@/components/xhtml/15_Production_History__Part_3__The'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML16_RECEPTION_AND_AFTER_LIFE from '@/components/xhtml/16_Reception_and_After_Life'
 import XHTML17_CODA from '@/components/xhtml/17_Coda'
 import XHTML18_ACKNOWLEDGMENTS from '@/components/xhtml/18_Acknowledgments'
 import XHTML19_NOTES from '@/components/xhtml/19_Notes'
 import XHTML20_LEGO_BIBLIOGRAPHY from '@/components/xhtml/20_LEGO_Bibliography'
 import XHTML21_INDEX from '@/components/xhtml/21_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Prologue",
 			"name" : "xhtml/06_Prologue",
 			"component" : XHTML06_PROLOGUE
 		},
 		{
 			"path" : "/xhtml/07_The_World_of_Animation_and_the_A",
 			"name" : "xhtml/07_The_World_of_Animation_and_the_A",
 			"component" : XHTML07_THE_WORLD_OF_ANIMATION_AND_THE_A
 		},
 		{
 			"path" : "/xhtml/08_The_LEGO_Movie_as_Savvy_Cinema",
 			"name" : "xhtml/08_The_LEGO_Movie_as_Savvy_Cinema",
 			"component" : XHTML08_THE_LEGO_MOVIE_AS_SAVVY_CINEMA
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js